module.exports = __webpack_public_path__ + "img/rotweinglow.a5f7e9d9.jpg";